import React from 'react';
import Header from './components/header';
import './index.css';
import './services.css';
import mobile from './assets/mobile-development.svg';
import mobileSelected from './assets/mobile-development-selected.svg';
import uiux from './assets/uiux.svg';
import uiuxSelected from './assets/uiux-selected.svg';
import webdevelopment from './assets/web-development.svg';
import webdevelopmentSelected from './assets/web-development-selected.svg';
import fullstack from './assets/fullstack-development.svg';
import fullstackSelected from './assets/fullstack-development-selected.svg';
import aws from './assets/aws.svg';
import awsSelected from './assets/aws-selected.svg';
import api from './assets/api.svg';
import apiSelected from './assets/api-selected.svg';
import datamining from './assets/data-mining.svg';
import dataminingSelected from './assets/data-mining-selected.svg';
import scripting from './assets/scripting.svg';
import scriptingSelected from './assets/scripting-selected.svg';
import BannerSection from './components/banner';
import Footer from './components/footer';
import SlideUpOnScroll from './components/slide-up';
import PageTitle2Cols from "./components/page-title-2-cols";

class Service extends React.Component {

    render() {
        return (
            <div className={`service`}
                 onMouseEnter={() => this.setState({ isHovered: true })}
                 onMouseLeave={() => this.setState({ isHovered: false })} >

                <img className='service-image mb-2' src={ this.state && this.state.isHovered ? this.props.service.hoverImage || this.props.service.image : this.props.service.image } alt={this.props.service.name} />

                <div className={`service-title t5 mb-2 ${this.props.service.css }`}>{this.props.service.name}</div>

                <div className='service-description b2'>
                    <div className="description-text">{this.props.service.description}</div>
                </div>

            </div>
        );
    }
}

class Services extends React.Component {
    
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    
    render() {

        const services = [
            {
                name: "UI & UX Design",
                description: "We design intuitive, user-centered interfaces that elevate digital experiences and drive engagement across web and mobile platforms. From wireframes to polished prototypes, our UI/UX process combines strategy, creativity, and usability to turn ideas into seamless, impactful products.",
                image: uiux,
                hoverImage: uiuxSelected,
            },
            {
                name: "Web Development",
                description: "We creat web applications of all sizes, from complex, large-scale platforms to smaller, focused projects and even landing pages. We can transform your designs or collaborate with you to define the UI components. All our solutions include mobile-friendly, responsive designs as standard.",
                image: webdevelopment,
                hoverImage: webdevelopmentSelected,
            },
            {
                name: "Mobile Development",
                description: "If you are looking for an Android development expert, you're in the right place. We can start building your application immediately, ensuring it's functional, fluid, and beautiful. We're ready to discuss your requirements and UI/UX challenges, and happy to brainstorm with you to find the perfect solution.",
                image: mobile,
                hoverImage: mobileSelected
            },
            {
                name: "Full-Stack Development",
                description: "We 're proficient in both back-end and front-end development, using technologies we know best. While we're always open to learning new skills when needed, our focus is on delivering high-quality code on time. Your feedback is invaluable as we strive to continuously improve our collaboration.",
                image: fullstack,
                hoverImage: fullstackSelected
            },
            {
                name: "Amazon Web Services",
                description: "Our services bridge the gap between business objectives and cloud technology. We can help organizations migrate existing workloads, build new cloud-native applications, and optimize their AWS environments for performance, security, and cost-efficiency.",
                image: aws,
                hoverImage: awsSelected
            },
            {
                name: "API Development",
                description: "Seamlessly connect your systems! We can build robust, secure, and scalable APIs, enabling smooth data exchange and enhanced functionality for your applications. Integrate with third-party services and unlock new possibilities for your business.",
                image: api,
                hoverImage: apiSelected
            },
            {
                name: "Data Mining",
                description: "Need to extract valuable information from the web? We're experts in web scraping, ready to efficiently collect the specific data you need from any online source. Whether it's market research, competitor analysis, or lead generation, we'll help you gain a crucial data advantage.",
                image: datamining,
                hoverImage: dataminingSelected
            },
            {
                name: "Scripting",
                description: "I can develop both the back-end as well as the front end. I am ok with any technologies that we decide to use. I have no problem with learning new tech skills in case time permits.  I do my best to deliver on time good quality code and I am glad to receive your feedback to better improve our working relation.",
                image: scripting,
                hoverImage: scriptingSelected
            },
        ];

        return (
            <div id="all-sections" className='section-background-2'>
                <Header version="blue" className='with-bottom-border-2' />

                <PageTitle2Cols title={'Solutions and services'}
                           subtitle={"From concept to completion, our development services transform your vision into robust, scalable, and innovative solutions. We specialize in crafting software, web, and mobile applications tailored to your unique needs, ensuring exceptional user experiences."}
                           className="primary-color white-color-txt" />

                <div className='blue-band primary-color' />


                <div className='section development-services page-padding mb-3 services-up'>
                    { services.map( (service, index) => <SlideUpOnScroll> <Service key={index} service={service} /> </SlideUpOnScroll>)}
                </div>


                <BannerSection />
                
                <Footer />
            </div>
        );
    }
}

export default Services;